.container {
  display: grid;
  grid-template-columns: 330px 1fr;
  gap: 20px;
}
